import lodash from 'lodash';
import { ISqlBaseModel } from '../modelV2/sql_base_model';

export interface IOptionType {
    label : string;
    value : number | string;
}

export class OptionType {
    public static fromDataModel = function<T extends ISqlBaseModel>(dataModel : T) : IOptionType {
        let labelNameOrDescription = '';

        let codeAdded = false;
        let nameAdded = false;

        if ('code' in dataModel && typeof dataModel.code === 'string' && dataModel.code !== '') {
            labelNameOrDescription += `${dataModel.code} `;
            codeAdded = true;
        }

        if ('name' in dataModel && typeof dataModel.name === 'string' && dataModel.name !== '') {
            labelNameOrDescription += `${dataModel.name} `;
            nameAdded = true;
        }

        if ('description' in dataModel
            && typeof dataModel.description === 'string'
            && dataModel.description !== ''
            && (!codeAdded || !nameAdded)) { // We don't want to add a description if the code and name have already been added.
            labelNameOrDescription += `${dataModel.description} `;
        }

        if (labelNameOrDescription === '') {
            return {
                label: 'Label Not Found',
                value: dataModel.id,
            };
        }

        const stringPartitions = labelNameOrDescription.trim().split(' ');

        if (stringPartitions.length > 1) {
            const firstSection = lodash.first(stringPartitions) ?? '';
            const lastSection = labelNameOrDescription.substring(firstSection.length);

            return {
                label: `(${firstSection}) - ${lastSection}`,
                value: dataModel.id,
            };
        } else {
            return {
                label: labelNameOrDescription.trim(),
                value: dataModel.id,
            };
        }
    }
}